import type { ArdoqId, APIOrganizationUser } from '@ardoq/api-types';
import { ViewIds } from '@ardoq/api-types';
import type { PureGraphEdge } from '@ardoq/graph';
import { VOID_REPRESENTATION_DATA } from '@ardoq/global-consts';
import { VIEWPOINT_MODE_RELATIONSHIPS_DIAGRAM_EMPTY_STATE } from 'tabview/relationshipDiagrams/consts';
import { DEFAULT_WORKSPACE_MODE_SETTINGS } from 'views/environmentals/viewSettings/defaultStreamState';
import { getDefaultRelationshipDiagramsViewInterface } from 'tabview/relationshipDiagrams/viewModel$/getDefaultRelationshipDiagramsViewInterface';
import type { WorkspaceRelationshipsViewSourceData } from '../types';

type ViewInterface = WorkspaceRelationshipsViewSourceData['viewInterface'];

export const getWorkspaceModeInitialState = (
  viewInstanceId: WorkspaceRelationshipsViewSourceData['viewInstanceId']
): WorkspaceRelationshipsViewSourceData => ({
  ...VIEWPOINT_MODE_RELATIONSHIPS_DIAGRAM_EMPTY_STATE,
  edges: {
    byId: new Map<string, PureGraphEdge>(),
    add: [],
    update: [],
    remove: [],
  },
  viewSettings: DEFAULT_WORKSPACE_MODE_SETTINGS[ViewIds.RELATIONSHIPS_3],
  viewInstanceId,
  isViewpointMode: false,
  viewInterface: getDefaultRelationshipDiagramsViewInterface(),
  users: [] as APIOrganizationUser[],
  noContext: false,
  noConnectedComponents: false,
  traversedIncomingReferenceTypes: [],
  traversedOutgoingReferenceTypes: [],
  referenceTypes: [],
  quickPerspectiveReferenceTypeFilters: null,
  getRepresentationData: () => null,
  colorFilterIdsByComponentId: new Map(),
  colorFilterIdsByReferenceId: new Map(),
  componentRepresentationDataByComponentId: new Map(),
});

/** The representation lookup the reset reducer installs on each reset. */
export const getWorkspaceModeRepresentationDataGetter =
  (viewInterface: ViewInterface) => (componentId: ArdoqId) =>
    viewInterface.getRepresentationData(componentId) ??
    VOID_REPRESENTATION_DATA;
